export default __webpack_public_path__ + "static/media/livePhoto.8f4701d1.jpg";